module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_PromoAngel02.10e2a020.jpg";